"use client";

import { useEffect } from "react";
import Link from "next/link";
import { Container } from "@/components/layout/container";
import { Button } from "@/components/ui/button";
import { Icon } from "@/components/icon";
import { ru } from "@/content/ru";

/**
 * Страница ошибки сервера (500). Клиентская — Next требует 'use client'
 * для error-страниц. Оболочку (шапка/подвал) не переиспользуем: она
 * серверная и может сама упасть, поэтому показываем автономный экран.
 */
export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Логируем на стороне браузера; детали не показываем пользователю
    console.error(error);
  }, [error]);

  const t = ru.ui.errors;

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center bg-background">
      <Container className="flex flex-col items-center text-center">
        <span className="flex size-14 items-center justify-center rounded-2xl border border-border/60 bg-muted/40">
          <Icon name="Hammer" className="size-7 text-primary" />
        </span>
        <h1 className="mt-6 text-3xl font-semibold tracking-tight sm:text-4xl">{t.serverTitle}</h1>
        <p className="mt-3 max-w-md text-muted-foreground">{t.serverText}</p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Button onClick={reset}>
            <Icon name="ArrowRight" className="size-4" />
            {t.retry}
          </Button>
          <Button asChild variant="outline">
            <Link href="/">{t.backHome}</Link>
          </Button>
        </div>
      </Container>
    </div>
  );
}
